import React from 'react';
import { Mail, MapPin, Linkedin } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { personalInfo } from '../mock';

const Contact = ({ isVisible }) => {
  const contactInfo = [
    {
      icon: Mail,
      label: 'Email',
      value: personalInfo.email,
      link: `mailto:${personalInfo.email}`
    },
    {
      icon: MapPin,
      label: 'Location',
      value: personalInfo.location
    },
    {
      icon: Linkedin,
      label: 'LinkedIn',
      value: 'Connect with me',
      link: `https://${personalInfo.linkedin}`
    }
  ];

  return (
    <section id="contact" data-section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div
          className={`transition-all duration-1000 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 text-center mb-4">
            Get In Touch
          </h2>
          <div className="w-24 h-1 bg-blue-700 mx-auto mb-6"></div>
          <p className="text-center text-slate-600 mb-12 max-w-2xl mx-auto">
            I'm currently seeking a 6-month internship in International Human Resources starting January 2027.
            Feel free to reach out!
          </p>

          <div className="max-w-3xl mx-auto">
            {/* Contact Information */}
            <div>
              <h3 className="text-2xl font-bold text-blue-900 mb-6 text-center">Contact Information</h3>
              <div className="space-y-4">
                {contactInfo.map((item, index) => {
                  const Icon = item.icon;
                  return (
                    <Card key={index} className="border-2 border-slate-200 hover:border-blue-700 transition-all duration-300">
                      <CardContent className="p-4 flex items-center gap-4">
                        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                          <Icon className="text-blue-700" size={20} />
                        </div>
                        <div className="flex-1">
                          <p className="text-sm text-slate-600 mb-1">{item.label}</p>
                          {item.link ? (
                            <a
                              href={item.link}
                              target={item.icon === Linkedin ? '_blank' : undefined}
                              rel={item.icon === Linkedin ? 'noopener noreferrer' : undefined}
                              className="text-blue-900 font-medium hover:text-blue-700 transition-colors"
                            >
                              {item.value}
                            </a>
                          ) : (
                            <p className="text-blue-900 font-medium">{item.value}</p>
                          )}
                        </div>
                      </CardContent>
                    </Card>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
